<!--
  AppSidebar · 左侧导航菜单
  - 固定宽度 200px，包含 Logo + 导航项（首页/课程包/播放设置）
  - RouterLink 自动高亮当前路由
-->
<template>
  <aside class="sidebar">
    <div class="logo">
      <span class="logo-emoji">🎓</span>
      <span class="logo-text">SunnyLearn</span>
    </div>

    <nav class="nav">
      <RouterLink to="/" class="nav-item">
        <span class="nav-icon">🏠</span>
        <span class="nav-label">首页</span>
      </RouterLink>
      <RouterLink to="/packs" class="nav-item">
        <span class="nav-icon">📚</span>
        <span class="nav-label">课程包</span>
      </RouterLink>
      <RouterLink to="/settings" class="nav-item">
        <span class="nav-icon">⚙️</span>
        <span class="nav-label">播放设置</span>
      </RouterLink>
    </nav>

    <div class="sidebar-footer">
      <div class="ver">v1.0 · Router</div>
    </div>
  </aside>
</template>

<script setup>
// 纯展示组件，无逻辑
</script>

<style scoped>
.sidebar {
  width: 200px;
  flex-shrink: 0;
  background: var(--panel);
  border-right: 1px solid var(--line);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  height: 100vh;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 18px 18px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 12px;
}
.logo-emoji { font-size: 22px; }
.logo-text {
  font-weight: 700;
  font-size: 16px;
  background: linear-gradient(135deg, var(--accent), var(--accent2));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.nav { flex: 1; display: flex; flex-direction: column; gap: 4px; padding: 0 10px; }
.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  color: var(--mute);
  text-decoration: none;
  font-size: 14px;
  transition: all .15s ease;
  border: 1px solid transparent;
}
.nav-item:hover {
  background: #1a2550;
  color: var(--ink);
}
.nav-item.router-link-exact-active {
  background: linear-gradient(135deg, #2a499e, #5a2fa0);
  color: #fff;
  border-color: var(--accent);
  box-shadow: 0 4px 16px #6ea8ff22;
}
.nav-icon { font-size: 16px; width: 20px; text-align: center; }
.sidebar-footer { padding: 12px 18px; border-top: 1px solid var(--line); }
.ver { color: var(--mute); font-size: 11px; opacity: 0.6; }
</style>
